import React from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {EvaArrowIosBackFill} from './icons/BackButton'

export default function CampaignConfirmation() {
  let navigate = useNavigate()
  const location = useLocation()
  const {startDate, endDate,time} = location.state || {}
  console.log(" -- location  --");
  console.log(location);
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          cursor: 'pointer',
          alignContent: 'center',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
        onClick={() => navigate(-1)}
      >
        <div style={{padding: 5, backgroundColor: 'white', borderRadius: 100, marginRight: 5}}>
          <EvaArrowIosBackFill />
        </div>
        <p style={{fontSize: 14, fontWeight: 'bold', margin: 0}}>Back</p>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          paddingRight: 30,
          paddingLeft: 50,
          marginTop: 20,
        }}
      >
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#B0B0B0',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            1
          </p>
          <p style={{fontSize: 14, marginLeft: 5, color: '#B0B0B0'}}>Create Campaign</p>
        </div>

        <hr style={{width: 170, marginLeft: 5, marginRight: 5, color: '#B0B0B0'}} />
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#B0B0B0',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            2
          </p>
          <p style={{fontSize: 14, marginLeft: 5}}>Select Recipients</p>
        </div>

        <hr style={{width: 170, marginLeft: 5, marginRight: 5}} />
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#B0B0B0',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            3
          </p>
          <p style={{fontSize: 14, marginLeft: 5}}>campaign periods</p>
        </div>

        <hr style={{width: 170, marginLeft: 5, marginRight: 5}} />
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#2ABD84',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            4
          </p>
          <p style={{fontSize: 14, marginLeft: 5, color: '#2ABD84'}}>Confirm</p>
        </div>
      </div>
      <div
        style={{
          marginRight: 30,
          marginLeft: 30,
          marginTop: 10,
          backgroundColor: 'white',
          paddingRight: 30,
          paddingLeft: 30,
          paddingTop: 60,
          paddingBottom: 60,
          borderRadius: 10,
        }}
      >
        <h2 style={{color: '#736F6F', fontSize: 36, textAlign: 'center'}}>Confirmation</h2>
        <div style={{textAlign: 'center', marginTop: 50, marginBottom: 10}}>
          <p style={{fontSize: 20, color: '#4A4747'}}>Scheduled Time</p>
          <p style={{color: '#000', fontSize: 24, fontWeight: 'bold'}}>
            {`${startDate} to ${endDate}`}
          </p>
        </div>
        <div style={{textAlign: 'center', marginTop: 10, marginBottom: 50}}>
          <p style={{color: '#000', fontSize: 24, fontWeight: 'bold'}}>
            {time}
          </p>
        </div>
        <p style={{fontSize: 20, color: '#898484', textAlign: 'center'}}>
          {/* Select to confirm to scheduled campaign */}
        </p>
        {/* <div className='d-flex justify-content-end mt-3'>
          <Link
            to='/campaign/add-successful'
            type='submit'
            className='btn'
            style={{
              padding: '10px 70px',
              borderRadius: 20,
              backgroundColor: '#202020',
              color: '#DBDEE0',
              marginTop: 50,
            }}
            // onClick={handleFormSubmit}
          >
            Confirm
          </Link>
        </div> */}
      </div>
    </>
  )
}
